// extracted by mini-css-extract-plugin
module.exports = {"homeSection":"home-module--home-section--3wjKL"};